export const OM_ORDER_DETAIL_SLICE_NAME = 'om_detail';
